<template>
    <div>
      <SearchFilters
        :showSearchBox="showSearchBox"
        :selectedBusinessId="selectedBusinessId"
        :selectedBranchId="selectedBranchId"
        :userBusinesses="userBusinesses"
        :userBranches="userBranches"
        :getLocalizedName="getLocalizedName"
        @businessChange="handleBusinessChange"
        @branchChange="handleBranchesChange"
      />
      <b-container fluid>
        <b-row class="mb-3">
          <b-col cols="12" class=" ">
            <div class="iq-card ">
              <div class="iq-card-header ">
                <div class="iq-header-title">
                  <h4 class="card-title">Permissions List</h4>
                </div>   
              </div>    
              <div class="iq-card-body">
                <SearchUsersForm :business-id="selectedBusinessId" ref="SearchUsersForm"
                         :reservation-errors="null"
                         :show-add-user="false"
                         @setUser="setUserId"
                       />

                <div v-if="userId && selectedBranchId" class="form-group mb-0 ml-2 d-flex align-items-center">
                  <b-form-checkbox v-model="isDashboardAccess" @change="dashboardAccess"/>
                  <label class="mb-0 ml-0">Dashboard Access</label>
                </div>
                <div class="card-body row" v-if="userId && selectedBranchId">
                  <template v-if="isDashboardAccess" v-for="(service, serviceName, index) in permissionServices">
                    <div class="col-sm-2 d-flex align-items-end pb-3">{{ serviceName }}</div>
                    <div class="col-sm-10">
                      <div class="row">
                        <template v-for="(action, actionName) in permissionsActions">
                          <div class="col-sm-3">
                            <div class="row form-group" v-if="index === 0">
                              <b-form-checkbox v-model="toggleCheckAll[action]" @change="()=> toggleCheck(action)"></b-form-checkbox>
                              <label>Check all</label>
                            </div>
                            <div class="row form-group">
                              <b-form-checkbox
                                :class="serviceName"
                                v-model="userPermissions[`${service}.${action}`]"
                                @change="updateCheckAllState"
                                :value="true"/>
                              <label>{{ actionName }}</label>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                  <div class="mb-3">
                    <b-spinner
                      v-if="loading"
                      variant="primary"
                      label="Spinning"
                    ></b-spinner>
                    <button v-else class="btn btn-primary " @click="setUserPermissions">
                      <i class="fa fa-save"></i> Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import { core } from "@/config/pluginInit";
  import SearchFilters from "@/components/SearchFilters.vue";
import SearchUsersForm from "../Reservations/SearchUsersForm.vue";
import { getPermissionsActions, 
        getPermissionsServices, 
        getUserPermissions, 
        setUserPermissions 
      } from "@/API/PermissionsAPIs";
import { submitAndNotify } from "@/helpers/utils";
  export default {
    name: "PermissionsList",
    components: {SearchFilters, SearchUsersForm },
    data() {
      return {
        loading: false,
        selectedBusinessId: null,
        selectedBusiness: null,
        selectedBranchId: null,
        showSearchBox: false,
        isDashboardAccess: false,
      userId: null,
      userPermissions: {},
      permissionServices: [],
      permissionsActions: [],
      toggleCheckAll: {
        read: false,
        update: false,
        create: false,
        delete: false,
      },
      };
    },
    computed: {
      currentLocale() {
        return this.$i18n.locale;
      },
      userBusinesses() {
        return this.$store.state.User.user.business || [];
      },
      userBranches() {
      return this.selectedBusiness ? this.selectedBusiness.branches || [] : [];
    }
    },
    mounted() {
      core.index();
      this.initializeBusiness();
    },
    methods: {
      async getBranchData() {
      if (!this.selectedBranchId || !this.selectedBusinessId)
        return;
      this.permissionServices = await getPermissionsServices({
        'businessId': this.selectedBusinessId,
        'branchId': this.selectedBranchId,
      });
      this.permissionsActions = await getPermissionsActions({
        'businessId': this.selectedBusinessId,
        'branchId': this.selectedBranchId,
      });
    },
    setUserId(user) {
      this.userId = user?.id;
      if (this.userId) {
        this.getUserPermissions();
        this.getBranchData();
      } else {
        this.userPermissions = {};
        this.userId = null;
      }
    },

    dashboardAccess(value) {
      this.isDashboardAccess = value;
    },

    async setUserPermissions() {
      let acceptedPermissions
      if (this.isDashboardAccess === true) {
        acceptedPermissions = Object.keys(this.userPermissions).map((key) => this.userPermissions[key] ? key : false);
      } else {
        acceptedPermissions = [];
      }
      submitAndNotify(
        this,
        setUserPermissions({
          'businessId': this.selectedBusinessId,
          'branchId': this.selectedBranchId,
          'userId': this.userId,
          'dashboard_access': this.isDashboardAccess,
          'permissions': acceptedPermissions,
        }),
      )
    },
    toggleCheck(actionName) {
      Object.values(this.permissionServices).forEach(serviceName => {
        this.$set(
          this.userPermissions,
          `${serviceName}.${actionName}`,
          this.toggleCheckAll[actionName]
        );
      });

    },

    // Optional: Update check all state when individual checkboxes change
  
    updateCheckAllState() {
      this.$nextTick(); // Ensure Vue updates the model
    },

    async getUserPermissions() {
      let response = await getUserPermissions({
        'businessId': this.selectedBusinessId,
        'branchId': this.selectedBranchId,
        'userId': this.userId
      });
     this.isDashboardAccess = response.dashboard_access;
      let permissions = response.permissions;
      this.dashboardAccess(response.dashboard_access);
      let newPermissions = {};
      permissions?.map(p => {
        newPermissions[p.replace(`branch.${this.selectedBranchId}.`, '')] = true
      })
      this.userPermissions = newPermissions;
    },
    handleBusinessChange(newValue) {
      if (newValue !== this.selectedBusinessId) {
        this.selectedBusinessId = newValue;
      }
    },
    handleBranchesChange(newValue) {
      if (newValue !== this.selectedBranchId) {
        this.selectedBranchId = newValue;
        this.getBranchData();
      }
    },
    initializeBusiness() {
      const user = this.$store.state.User.user;
      if (user?.business?.length && !this.selectedBusinessId) {
        this.selectedBusinessId = user.business[0].id;
        this.selectedBranchId = user.business[0].branches[0].id;
        this.setUserId()
        
      }
    },
      getLocalizedName(locales) {
        const locale = this.$i18n.locale || "en";
        const localizedData =
          locales.find(l => l.locale === locale) || locales[0];
        return localizedData ? localizedData.name : "No Name";
      },
    
    },
    watch: {
    selectedBusinessId(newBusinessID) {
      this.selectedBusiness =
        this.userBusinesses.find(b => b.id === newBusinessID) || null;
      this.selectedBranchId = this.selectedBusiness?.branches[0]?.id || null;
    },
    selectedBranchId(newBranchId, oldBranchId) {
      if (oldBranchId !== null && newBranchId !== oldBranchId) {
        this.getBranchData();
      }
    },
    userBusinesses: {
      handler(newBusinesses) {
        if (newBusinesses.length > 0 && !this.selectedBusinessId) {
          this.selectedBusinessId = newBusinesses[0].id;
        }
      },
      deep: true
    }
  }
  };
  </script>
  
  <style scoped></style>
  